/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from 'react'
import { format } from 'date-fns'
import { BackLink } from 'src/components/common'
import {
  getInvitesRequest,
  acceptStudentInviteRequest,
  rejectStudentInviteRequest,
  cancelStudentInviteRequest,
  deleteStudentInviteRequest,
  acceptTeacherInviteRequest,
  rejectTeacherInviteRequest,
  cancelTeacherInviteRequest,
  deleteTeacherInviteRequest,
} from 'src/services/api.service'
import { useNotification } from 'src/contexts/notification.context'
import { useAuth } from 'src/contexts/auth.context'
import { routes } from 'src/navigation/routes'
import { getAvatar } from 'src/tools/helpers'

export const Invites = () => {
  const { user } = useAuth()
  const { wrapCallback, showErrorHelper, showConfirm } = useNotification()

  const [receivedItems, setReceivedItems] = useState([])
  const [sentItems, setSentItems] = useState([])

  const [loading, setLoading] = useState(false)
  const [filter, setFilter] = useState({ type: 'received' })

  const fetchData = async () => {
    try {
      setLoading(true)
      // console.log('user', user.id, user.email)
      const response = await getInvitesRequest()
      setReceivedItems(
        response.data.items.filter(
          (x) =>
            String(x.inviter_user_id) === String(user.id) ||
            x.inviter_email === user.email,
        ),
      )
      setSentItems(
        response.data.items.filter(
          (x) =>
            String(x.invited_user_id) === String(user.id) ||
            x.invited_email.trim() === user.email.trim(),
        ),
      )
    } catch (error) {
      showErrorHelper(error)
    }
    setLoading(false)
  }

  useEffect(() => {
    fetchData()
  }, [])

  const handleAccept = (item) => () => {
    wrapCallback(async () => {
      if (user.role_id === 1) {
        await acceptTeacherInviteRequest(item.id)
      } else {
        await acceptStudentInviteRequest(item.id)
      }
    })
    fetchData()
  }

  const handleDecline = (item) => () => {
    showConfirm({
      title: 'Are you sure?',
      body: `Do you really want to decline invite?`,
      actions: {
        onOk: async () => {
          wrapCallback(async () => {
            if (user.role_id === 1) {
              await rejectTeacherInviteRequest(item.id)
            } else {
              await rejectStudentInviteRequest(item.id)
            }
          })

          fetchData()
        },
      },
    })
  }

  const handleCancel = (item) => () => {
    showConfirm({
      title: 'Are you sure?',
      body: `Do you really want to cancel invite?`,
      actions: {
        onOk: async () => {
          wrapCallback(async () => {
            if (user.role_id === 1) {
              await cancelTeacherInviteRequest(item.id)
            } else {
              await cancelStudentInviteRequest(item.id)
            }
          })
          fetchData()
        },
      },
    })
  }

  const handleDelete = (item) => () => {
    showConfirm({
      title: 'Are you sure?',
      body: `Do you really want to delete invite?`,
      actions: {
        onOk: async () => {
          wrapCallback(async () => {
            if (user.role_id === 1) {
              await deleteTeacherInviteRequest(item.id)
            } else {
              await deleteStudentInviteRequest(item.id)
            }
          })
          fetchData()
        },
      },
    })
  }

  if (loading) {
    return null;
  }

  return (
    <>
      <div className="sectionHb-top">
        <BackLink to={routes.root} />
        <h2 className="sectionHb-title">New invitations</h2>
      </div>

      <div className="sectionHb-block review invites">
        <div className="sectionHb-block__wrap">
          <div className="allTabs">
            <ul className="tab-list assign-menu">
              <li>
                <a
                  onClick={() => {
                    setFilter({ type: 'received' })
                  }}
                  className={filter.type === 'received' ? 'active' : ''}
                >
                  Invited by you <span>{receivedItems.length}</span>
                </a>
              </li>
              <li>
                <a
                  onClick={() => {
                    setFilter({ type: 'sent' })
                  }}
                  className={filter.type === 'sent' ? 'active' : ''}
                >
                  You’ve been invited <span>{sentItems.length}</span>
                </a>
              </li>
            </ul>

            <div
              className={filter.type === 'received' ? 'tab tab-active' : 'tab'}
            >
              <div className="invites-list">
                {receivedItems.map((item) => (
                  <div key={item.id} className="invites-item">
                    <div className="invites-img">
                      {getAvatar(item?.invited)}
                    </div>
                    <div className="invites-info">
                      <div className="invites-top">
                        <span className="invites-name">
                          {item?.invited?.first_name} {item?.invited?.last_name}
                        </span>
                        {item.inviter.role_id === 1 && (
                          <span className="invites-tag">Teacher</span>
                        )}
                        {item.inviter.role_id === 2 && (
                          <span className="invites-tag student">Student</span>
                        )}
                        {item.inviter.role_id === 3 && (
                          <span className="invites-tag">Parent</span>
                        )}
                      </div>
                      <span className="invites-date">
                        {format(new Date(item.created_at), 'MMM d')}
                      </span>
                      <div className="invites-row">
                        <i className="hb-ico star-ico-5-big" />
                        {item?.location && (
                          <span className="invites-city">{item?.location}</span>
                        )}
                      </div>
                      <p>
                        You Invite to join <b>{item?.classroom?.name}</b> to
                        study <b>{item?.classroom?.subject?.name}</b>,{' '}
                        <b>{item?.classroom?.grade?.name}</b>
                      </p>

                      <p style={{ textTransform: 'capitalize' }}>
                        {item.status}
                      </p>

                      {item.status === 'created' ? (
                        <div className="buttons-row">
                          <a
                            href="#"
                            className="second-btn"
                            onClick={handleCancel(item)}
                          >
                            <i className="hb-ico plus-ico" />
                            Never mind
                          </a>
                          <a href="#" className="second-btn">
                            <i className="hb-ico mail-ico" />
                            Remind
                          </a>
                        </div>
                      ) : (
                        <div className="buttons-row">
                          <a
                            href="#"
                            className="second-btn"
                            onClick={handleDelete(item)}
                          >
                            Delete
                          </a>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className={filter.type === 'sent' ? 'tab tab-active' : 'tab'}>
              <div className="invites-list">
                {sentItems.map((item) => (
                  <div key={item.id} className="invites-item">
                    <div className="invites-img">
                      {getAvatar(item?.inviter)}
                    </div>
                    <div className="invites-info">
                      <div className="invites-top">
                        <span className="invites-name">
                          {item.inviter.first_name} {item.inviter.last_name}
                        </span>
                        {item.inviter.role_id === 1 && (
                          <span className="invites-tag">Teacher</span>
                        )}
                        {item.inviter.role_id === 2 && (
                          <span className="invites-tag student">Student</span>
                        )}
                        {item.inviter.role_id === 3 && (
                          <span className="invites-tag">Parent</span>
                        )}
                      </div>
                      <span className="invites-date">
                        {format(new Date(item.created_at), 'MMM d')}
                      </span>
                      <div className="invites-row">
                        <i className="hb-ico star-ico-5-big" />
                        {item.inviter?.location && (
                          <span className="invites-city">
                            {item.inviter?.location}
                          </span>
                        )}
                      </div>
                      {/* <p>You Invite to join <b>[ Name of the class ]</b> to study <b>[math]</b> <b>[grade 2]</b></p> */}
                      <p style={{ textTransform: 'capitalize' }}>
                        {Array.isArray(item.events) &&
                          item.events[item.events.length - 1][0]}
                      </p>
                      <p style={{ textTransform: 'capitalize' }}>
                        {item.status}
                      </p>
                      {item.status === 'created' ? (
                        <div className="buttons-row">
                          <a
                            href="#"
                            className="second-btn"
                            onClick={handleAccept(item)}
                          >
                            <i className="hb-ico plus-ico" />
                            Join class
                          </a>
                          <a
                            href="#"
                            className="second-btn"
                            onClick={handleDecline(item)}
                          >
                            <i className="hb-ico close-blue-ico" />
                            Not now
                          </a>
                        </div>
                      ) : (
                        <div className="buttons-row">
                          <a
                            href="#"
                            className="second-btn"
                            onClick={handleDelete(item)}
                          >
                            Delete
                          </a>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
